var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logs"},[_c('iframe',{staticStyle:{"display":"block","width":"100%","min-height":"950px"},attrs:{"id":"iframe","src":_vm.urlLogsIframe,"frameborder":"0","scrolling":"yes","seamless":"seamless"}})])}
var staticRenderFns = []

export { render, staticRenderFns }